'use client'

import { CommentList } from '../CommentList'

interface CommentsSectionProps {
  comments: Array<{
    id: number
    customerId: number
    comment: string
    time: string
    responseTo?: number | null
    customerName: string
    gravatarUrl?: string | null
  }>
}

export const CommentsSection = ({ comments }: CommentsSectionProps) => {
  const handleReply = (commentId: number, customerName: string) => {
    // This will be handled by the client-side comment form
    if (typeof window !== 'undefined') {
      ;(window as any).replyToComment?.(commentId, customerName)
    }
  }

  if (!comments || comments.length === 0) {
    return null
  }

  return (
    <div className="space-y-4">
      <div className="border-b border-gray-200 pb-3">
        <h2 className="text-2xl font-bold text-gray-900 mb-3">
          Reader comments
        </h2>
      </div>
      <CommentList comments={comments} onReply={handleReply} />
    </div>
  )
}
